export const screenSize = {
    mobile: '540px',
    tablet: '840px',
    desktop: '1200px',
    nav: '1060px',
  }